import * as FileManager from '../../SDK/FileManager'
import * as Util from '../../common/js/util'

const MoveCopy = {
  state: {
    isShow: false,
    title: '',
    flag: 'move',
    isRoot: true,
    currentPath: '',
    content: [],
    currentFolder: {},
    isShowCreate: false,
    isShowCopy: false,
    isShowMove: false,
    isSuccess: false,
    isBackReload: false
  },
  getters: {
  },
  mutations: {
    setIsBackReload (state, obj) {
      state.isBackReload = obj
    },
    setSuccess (state, obj) {
      state.isSuccess = obj
    },
    setTitle (state, obj) {
      state.title = obj
    },
    setMoveCopyFlag (state, obj) {
      state.flag = obj
      state.title = obj === 'move' ? '请选择要移动的位置' : '请选择要复制的位置'
    },
    setIsRoot (state, obj) {
      state.isRoot = obj
    },
    setIsShow (state, obj) {
      state.isShow = obj
    },
    setMoveCopyCurrentPath (state, obj) {
      state.currentPath = obj
    },
    getMoveCopyList (state, obj) {
      console.log('getMoveCopyList')
      state.currentFolder = obj
      state.content = []
      var contents = obj.content
      for (let i = 0; i < contents.length; i++) {
        var file = {}
        var item = contents[i]
        var d = Util.resolvePath(item.path, item.is_dir)
        item.type = d.type
        item.typeIcon = Util.typeIcon(d.type)
        item.name = d.name
        item.title = file.name
        item.filename = file.name
        item.size = Util.formatBytes(item.bytes)
        item.datetime = Util.formatDate(item.modified || item.datetime, 'yyyy-MM-dd' + ' hh:mm')
        item.authName = Util.getAuthNameByAccessMode(item.access_mode).authName
        if (item.dir_type === 2 || item.dir_type === 4) { // 2代表云端共享文件夹  4代表云端普通文件夹
          item.is_cloud = true
          if (item.dir_type === 2) {
            item.is_shared = true
          }
        } else {
          item.is_cloud = false
        }
        if (item.is_dir) {
          if (item.is_shared && item.is_team) {
            item.typeIcon = 'folder_team'
          } else if (item.is_shared && item.is_cloud) { // 云端文件被共享
            item.typeIcon = 'cloud_share'
          } else if (item.is_cloud) { // 云端文件
            item.typeIcon = 'folder_cloud'
          } else if (item.is_shared) {
            item.typeIcon = 'folder_share'
          } else if (item.is_team) {
            item.typeIcon = 'folder_team'
          } else {
            item.typeIcon = 'folder'
          }
        }
        switch (item.dir_type) {
          case 1 :
            item.category = '团队文件夹'
            break
          case 2 :
            item.category = '云端共享文件夹'
            break
          case 4 :
            item.category = '云端文件夹'
            break
          case 6 :
            item.category = '共享文件夹'
            break
          case 8 :
            item.category = '普通文件'
            break
          default :
            item.category = '普通文件夹'
            break
        }
        if (item.is_dir) {
          state.content.push(item)
        }
      }
    }
  },
  actions: {
    getMoveCopyList ({commit}, obj) {
      FileManager.metaData(obj.params).then(response => {
        commit('getMoveCopyList', response)
      }, err => {
        console.log(err)
      })
    },
    moveCopyAddFolder ({commit, rootState, dispatch}, obj) {
      let params = {
        path: '/' + rootState.movecopy.currentFolder.path + '/' + obj,
        path_type: rootState.movecopy.currentFolder.path_type,
        prefix_neid: rootState.movecopy.currentFolder.prefix_neid,
        from: rootState.movecopy.currentFolder.from
      }
      FileManager.createFolder(params).then(response => {
        commit('setAddFolderShow', false)
        let params = {path: rootState.movecopy.currentFolder.path,
          path_type: rootState.movecopy.currentFolder.path_type,
          prefix_neid: rootState.movecopy.currentFolder.prefix_neid,
          from: rootState.movecopy.currentFolder.from,
          limit: 1000,
          content_type: 'dir'
        }
        dispatch({
          type: 'getMoveCopyList',
          params: params
        })
      }, err => {
        if (err.type === 'error') {
          commit('setToast', {isShow: true, message: err.message, iconClass: 'icon-error'})
        }
      })
    },
    copy ({commit}, obj) {
      console.log('movecopy.js --- copy' + obj)
      FileManager.copy(obj.params).then(response => {
        commit('setSuccess', true)
        commit('setToast', {isShow: true, message: '复制成功', iconClass: 'icon-success'})
      }, err => {
        commit('setSuccess', false)
        commit('setProgress', {isShow: false})
        commit('setToast', {isShow: true, message: err.message, iconClass: 'icon-error'})
        console.log(err)
      })
    },
    move ({commit}, obj) {
      FileManager.move(obj.params).then(response => {
        commit('setSuccess', true)
        commit('setToast', {isShow: true, message: '移动成功', iconClass: 'icon-success'})
        commit('setIsBackReload', true)
      }, err => {
        commit('setSuccess', false)
        commit('setProgress', {isShow: false})
        commit('setToast', {isShow: true, message: err.message, iconClass: 'icon-error'})
        console.log(err)
      })
    }
  }
}
export default MoveCopy



// WEBPACK FOOTER //
// ./src/store/modules/movecopy.js